export default __webpack_public_path__ + "static/media/star_power_2.e4d49ced.png";